import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getLeads } from '../redux/leadsSlice';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ThankYou = () => {
    const [searchParams] = useSearchParams();
    const membershipId = searchParams.get('member');
    const dealName = searchParams.get('deal')?.replace(/-/g, ' ');
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    // Attempt to get deal from state passed via navigation
    const [deal, setDeal] = useState(location.state?.selectedDeal || null);

    // Access leads from Redux if we need to look up the deal
    const { data: leads = [], status } = useSelector((state) => state.leads);

    useEffect(() => {
        // Scroll to top on mount
        window.scrollTo(0, 0);

        // If deal is not in state but we have a dealName param, try to find it in Redux
        if (!deal && dealName) {
            if (status === 'idle') {
                dispatch(getLeads({ page: 1, type: "all" }));
            } else if (leads.length > 0) {
                const foundDeal = leads.find(d => d.name === dealName || d.deal_property_title === dealName); // Adjust matching logic as needed
                // Note: dealName in URL might be encoded or slugified. 
                // Since we rely on the logic in BecomeMember: `leads.find(d => d.name === dealParam)`
                // We should assume dealName corresponds to `d.name`
                const match = leads.find(d => d.name === dealName);
                if (match) {
                    setDeal(match);
                }
            }
        }
    }, [deal, dealName, leads, status, dispatch]);

    const handleBackToDeals = () => {
        navigate('/live-deals');
    };

    return (
        <main>
            <section className='cbp_layout_header'>
                <div className='container-fluid grey-border-b-1'>
                    <Header />
                </div>
            </section>

            <section className='cbp_layout_member' style={{ minHeight: '80vh', display: 'flex', alignItems: 'center' }}>
                <div className='container pt-md-5 pb-md-5 pt-2 pb-2'>
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-8 col-lg-6">
                            <div className="card shadow-lg border-0 rounded-4 text-center p-4">
                                <div className="card-body">
                                    <div className="mb-3 text-success">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor" className="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                        </svg>
                                    </div>

                                    <h3 className="card-title fw-bold mb-3 success-text">Thank You!</h3>
                                    <p className="card-text text-muted mb-2 fs-5">
                                        Your application has been submitted successfully.
                                    </p>

                                    {/* Membership ID Card */}
                                    <div className="bg-light p-3 rounded-3 mb-4 d-inline-block">
                                        <span className="text-secondary small d-block mb-1">Membership Application ID</span>
                                        <span className="fw-bold fs-7 text-primary">{membershipId}</span>
                                    </div>

                                    {/* Deal Details Card (if available) */}
                                    {deal && (
                                        <div className="card mb-4 border-0 shadow-sm bg-light overflow-hidden text-start">
                                            <div className="row g-0 align-items-center">
                                                <div className="col-4">
                                                    <img
                                                        src={deal.deal_image}
                                                        className="img-fluid h-100 w-100 object-fit-cover rounded-start"
                                                        alt={deal.deal_property_title}
                                                        style={{ maxHeight: '100px', objectFit: 'cover' }}
                                                    />
                                                </div>
                                                <div className="col-8">
                                                    <div className="card-body py-2">
                                                        <h6 className="card-title fw-bold mb-1 text-truncate" title={deal.deal_property_title}>
                                                            {deal.deal_property_title}
                                                        </h6>
                                                        <p className="card-text text-muted small mb-0">
                                                            Interested in this deal
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="d-flex justify-content-center">
                                        <button
                                            onClick={handleBackToDeals}
                                            className="btn btn-primary sin-button px-4 py-3 rounded-pill shadow-sm border-0"
                                            style={{ background: 'linear-gradient(to bottom, #0082CB 0%, #004E7A 100%)' }}
                                        >
                                            Explore Deals
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='cbp_layout footer-section'>
                <div className='container'>
                    <Footer />
                </div>
            </section>
        </main>
    );
};

export default ThankYou;
